import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { Contact } from 'common/store/genesys-cloud/external-contacts/models/contact.model';
import { WorkItemIntegration } from 'common/store/genesys-cloud/work-item-integrations/models/work-item-integrations.model';

@Component({
  selector: 'app-genesys-chat-widget-header',
  templateUrl: './genesys-chat-widget-header.component.html',
  styleUrls: ['./genesys-chat-widget-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatWidgetHeaderComponent {
  @Input()
  contact?: Contact;
  @Input()
  avatarThemeId: number;
  @Input()
  isExpandedMode: boolean;
  @Input()
  integrations: WorkItemIntegration[];
  @Input()
  openIntegrationPanels: WorkItemIntegration[];
  @Input()
  isCobrowseAllowed: boolean;
  @Input()
  isCobrowseActive: boolean;
  @Output()
  readonly minimize = new EventEmitter<void>();
  @Output()
  readonly toggleExpanded = new EventEmitter<void>();
  @Output()
  readonly toggleIntegration = new EventEmitter<string>();
  @Output()
  readonly toggleCobrowse = new EventEmitter<string>();
}
